module.exports = __webpack_public_path__ + "static/media/42-6.0fdc91a3.mp3";